// extracted by mini-css-extract-plugin
export default {"userTagWrapper":"index_userTagWrapper__gKJHr","iconContainer":"index_iconContainer__Bp3VK","nameContainer":"index_nameContainer__5q87o"};